export const prestaApp = {
  id: 14,
  name: "presta",
  showTestConnection: true,
  label: "Prestashop",
  logo: process.env.BASE_URL + "media/shopLogos/presta.svg",
  // "migration" = initial data import (products from the shop into Connect). Presta
  // does not offer it - the import flows were test-phase only and are archived
  // (CONNECT-7088). The shopimporter takeover ("Integration übernehmen") is a
  // different feature and is gated on shopImporterWorkflowId below.
  areaBlacklist: ["migration"],
  additional_params: {
    endpoint: "/orders?limit=1",
    authType: "basic-key"
  },
  environmentVariables: {
    presetId: process.env.VUE_APP_SCM_APP_PRESTA_PRESET_ID,
    testWorkflows: {
      product: process.env.VUE_APP_SCM_APP_TEST_PRODUCT_WORKFLOW_ID,
      salesOrder: process.env.VUE_APP_SCM_APP_PRESTA_TEST_ORDER_WORKFLOW_ID,
      stock: process.env.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID,
      tracking: process.env.VUE_APP_SCM_APP_TEST_TRACKING_WORKFLOW_ID,
      category: process.env.VUE_APP_SCM_APP_TEST_CATEGORY_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env.VUE_APP_SCM_APP_PRESTA_TEST_BATCH_ORDER_WORKFLOW_ID,
      tracking: process.env.VUE_APP_SCM_APP_TEST_BATCH_TRACKING_WORKFLOW_ID,
      receipt: process.env.VUE_APP_SCM_APP_TEST_BATCH_RECEIPT_WORKFLOW_ID,
      paymentTransactions:
        process.env.VUE_APP_SCM_APP_TEST_BATCH_PAYMENT_TRANSACTION_WORKFLOW_ID
    },
    xentralWorkflowId:
      process.env.VUE_APP_SCM_APP_PRESTA_REPORTING_XENTRAL_WORKFLOW_ID,
    CFLWorkflowId: process.env.VUE_APP_SCM_APP_PRESTA_REPORTING_CFL_WORKFLOW_ID,
    CFLDataSetId: process.env.VUE_APP_SCM_APP_PRESTA_REPORTING_CFL_DATASET_ID,
    syncBatchWorkflowId:
      process.env.VUE_APP_SCM_APP_PRESTA_REPORTING_SYNC_BATCH_WORKFLOW_ID,
    shopImporterWorkflowId:
      process.env.VUE_APP_SCM_APP_PRESTA_MIGRATION_SHOPIMPORTER_WORKFLOW_ID
  }
};
